// BESTIE SCREENING PACKAGES **************************************************************
// pathname: /v1/screening/billing/packages
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi/useSwrApi';
import type { ApiSchema } from '@type/api/apiUtilityFn';

interface UseSwrBestieScreeningPackagesProps {
  shouldFetch?: boolean;
}

type ScreeningPackageResponse = ApiSchema<'ScreeningPackage'>[];

/**
 * @description SWR: fetch bestie screening packages list.
 * @param props - { UseSwrBestieScreeningPackagesProps } - Configuration object with optional shouldFetch.
 */
export const useSwrBestieScreeningPackages = (props?: UseSwrBestieScreeningPackagesProps) => {
  const { shouldFetch = true } = props ?? {};

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ScreeningPackageResponse>({
    url: '/v1/screening/billing/packages',
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000 * 5, // 5 minutes
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
